import React, { useCallback, useContext, useEffect, useState } from 'react';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import { AccessRightDTO } from '@peartherapeutics/hylia-api-client';
import { DashboardContext } from 'components/screens/PatientDashboard/context';
import StatusBar from './StatusBar';
import Table from './Table';
import { rewardsService } from './services';

const Rewards = () => {
  // ==== STATE ==== //
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  // ==== CONTEXT ==== //
  const { rewardList, setRewardList, patientId, selectedAccessRight } =
    useContext(DashboardContext);

  // ===== METHODS ==== //
  const getRewardListData = useCallback(async () => {
    try {
      const rewards = await rewardsService.getPatientRewards(
        patientId!,
        selectedAccessRight!.id,
      );

      setRewardList({ ...rewards });

      setIsLoaded(true);
    } catch (e) {
      ErrorInterceptor.error(e);
    }
  }, [patientId, selectedAccessRight, setRewardList]);

  useEffect(() => {
    if (!rewardList) {
      getRewardListData();
    } else {
      setIsLoaded(true);
    }
  }, [getRewardListData, rewardList]);

  if (isLoaded && rewardList) {
    return (
      <div id="rewards-tab-id" data-testid="rewards-loaded">
        <StatusBar
          totalRewards={rewardList!.earnedRewardsCount}
          totalRewardAmount={rewardList!.sumEarnedRewards}
          isInAppCm={rewardList!.inAppCm || false}
        />
        <Table
          rewards={rewardList!.earnedRewards}
          isInAppCm={rewardList!.inAppCm || false}
        />
      </div>
    );
  }

  return <div data-testid="rewards-loading" />;
};

export default Rewards;
